// Wording for what the wallet holds.
import type { KeyKind } from "../crypto/keys";

export type Validity = { state: "valid" | "expired" | "not_yet_valid"; text: string };

/** A credential's validity in plain words, at `now`. */
export function validityLabel(validFrom?: string, validUntil?: string, now = Date.now(), locale?: string): Validity {
  if (validFrom && now < Date.parse(validFrom)) return { state: "not_yet_valid", text: "Not yet valid" };
  if (validUntil && now > Date.parse(validUntil)) return { state: "expired", text: "Expired" };
  if (!validUntil) return { state: "valid", text: "No end date" };
  const date = new Date(validUntil).toLocaleDateString(locale, { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
  return { state: "valid", text: `Valid until ${date}` };
}

/** "an Ed25519 key", "a P-256 key". */
export const keyPhrase = (kind: KeyKind): string => (kind === "Ed25519" ? "an Ed25519 key" : "a P-256 key");
